import initialState, {getters} from './initial-state'
import mutations from './mutations'
import actions from './actions'

const moduleForm = {
  name: 'form',
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions
}

export default moduleForm
